exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".payment-confirm{padding:10px 10px 0}.payment-confirm span{display:block;line-height:1.5}.modal-footer .btn-primary{background:#F5821F}\n", ""]);

